import { Location } from 'react-router-dom';

function determineNonOrganLink({ pathname }: Location) {
  const path = pathname.split('/').at(-1);

  switch (path) {
    case 'final-impressions':
      return 'final_impressions';
    case 'key-images':
      return 'key_images';
    case 'preview':
      return 'preview';
    case 'quality-review':
      return 'quality_review';
    case 'ai-findings':
      return 'ai_findings';
    case 'comparisons':
      return 'comparisons';
    case 'reason-for-scan':
      return 'reason_for_scan';
    default:
      return 'reason_for_scan';
  }
}

export function getSelectedLink(location: Location, organ?: string) {
  return organ ? organ.replace(/-/g, '_') : determineNonOrganLink(location);
}
